// @ts-nocheck
// Greif UI Kit = line-calendar
import * as React from "react";

const Calendar: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M18.72 11.127H5.28v7.855c0 .482.376.872.84.872h11.76c.464 0 .84-.39.84-.872zm-4.2-4.364v-.872H9.48v.872c0 .482-.376.873-.84.873s-.84-.391-.84-.873v-.872H6.12c-.464 0-.84.39-.84.872v2.618h13.44V6.763c0-.482-.376-.872-.84-.872H16.2v.872c0 .482-.376.873-.84.873s-.84-.391-.84-.873m5.88 12.219c0 1.446-1.128 2.618-2.52 2.618H6.12c-1.392 0-2.52-1.172-2.52-2.618V6.763c0-1.446 1.128-2.618 2.52-2.618H7.8v-.873c0-.482.376-.872.84-.872s.84.39.84.872v.873h5.04v-.873c0-.481.376-.872.84-.872s.84.39.84.872v.873h1.68c1.392 0 2.52 1.172 2.52 2.618z"
            />
        </svg>
    );
};

export default React.memo(Calendar);
